import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { ConnectedApp } from './App';
import store from './store';
import { Provider } from 'react-redux';
import { history } from './store/store';
import { ConnectedRouter } from 'connected-react-router';

import { CookiesProvider } from 'react-cookie';

import { SENTRY_DSN } from './constants/login';
import './i18n';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { AnalyticsHandlersProvider } from './analytics/__providers__/AnalyticsHandlersProvider';
import { FeatureFlagProvider } from './components/__providers__/FeatureFlagsContext';
import {
  purgePoisonedStoredCredential,
  USER_STORAGE_USER_KEY,
} from './utils/credentialGuard';

const hack: any = undefined;
Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  beforeSend(event) {
    return event;
  },
  tracesSampleRate: 1.0,
});

// Drop any poisoned stored credential before anything reads it (INV-0001 /
// TC-1000). Also re-purge if another tab — e.g. one still running an old
// bundle — writes the key again mid-session; the 'storage' event only fires
// for writes coming from other tabs.
purgePoisonedStoredCredential('boot');
window.addEventListener('storage', (event) => {
  if (event.key === USER_STORAGE_USER_KEY) {
    purgePoisonedStoredCredential('storage-event');
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <AnalyticsHandlersProvider>
    <Provider store={store}>
      <CookiesProvider>
        <FeatureFlagProvider>
          <ConnectedRouter history={history}>
            <ConnectedApp {...hack} />
          </ConnectedRouter>
        </FeatureFlagProvider>
      </CookiesProvider>
    </Provider>
  </AnalyticsHandlersProvider>,
);
